module.exports = __webpack_public_path__ + "static/media/employees.92e3c034.svg";